import React from 'react'
import { Intent } from '../../@types/intent'

export const content = new Map([
  [
    Intent.INDEPENDENT_SALE,
    {
      statusHeadline: 'Anfrage gesendet',
      statusContent:
        'Ein passender Experte wird sich bei dir melden, um eine unverbindliche Verkaufsberatung durchzuführen.',
      subHeadline: 'Jetzt inserieren und attraktiven Preis erzielen',
      additionalUlClass: '',
      ctaButton: 'Jetzt inserieren',
      bulletPoint1: (
        <span>
          <b>Größte Reichweite</b> bei Deutschlands <br className='palm-hide' />
          beliebtestem Immobilienportal nutzen¹.
        </span>
      ),
      bulletPoint2: (
        <span>
          <b>Höhere Verkaufspreise</b> als auf anderen <br className='palm-hide' />
          Plattformen erzielen².
        </span>
      ),
      bulletPoint3: (
        <span>
          <b>Umfassende Services</b> mit 96% Kunden- <br className='palm-hide' />
          zufriedenheit erleben³.
        </span>
      ),
    },
  ],
  [
    Intent.BUY,
    {
      statusHeadline: 'Immobilie erfolgreich bewertet',
      statusContent: 'Ein passender Experte wird sich bei dir melden, um eine unverbindliche Beratung durchzuführen',
      subHeadline: (
        <>
          In 3 Minuten zum individuellen <br className='lap-hide palm-hide' /> Finanzierungs
          <span className='medium-palm-and-bigger-hide'>
            <br />-
          </span>
          angebot
        </>
      ),
      additionalUlClass: 'additional-ul-class',
      ctaButton: 'Jetzt starten',
      bulletPoint1: <span>100% kostenlos & unverbindlich</span>,
      bulletPoint2: (
        <span>
          Deutschlandweit mehr als 2.500 <br className='palm-hide' />
          Anbieter
        </span>
      ),
      bulletPoint3: (
        <span>
          Über 300.000 Kunden vertrauen <br className='palm-hide' />
          uns jedes Jahr
        </span>
      ),
    },
  ],
  [
    Intent.RENT,
    {
      statusHeadline: 'Immobilie erfolgreich bewertet',
      statusContent: 'Das Ergebnis erhältst du zusätzlich per E-Mail.',
      subHeadline: (
        <span>
          Schneller ins Traumzuhause <br className='lap-hide palm-hide' />
          mit Mieter<span className='PlusDark dark'>Plus</span>
        </span>
      ),
      additionalUlClass: '',
      ctaButton: 'MieterPlus freischalten',
      bulletPoint1: (
        <span>
          Immer oben im Postfach <br className='palm-hide' />
          des Anbieters
        </span>
      ),
      bulletPoint2: (
        <span>
          Exklusive Anzeigen mit <br className='palm-hide' />
          vorzeitiger Kontaktaufnahme
        </span>
      ),
      bulletPoint3: (
        <span>
          Bewerbermappe mit aktuellem <br className='palm-hide' />
          SCHUFA-BonitätsCheck
        </span>
      ),
    },
  ],
  [
    Intent.LET,
    {
      statusHeadline: 'Immobilie erfolgreich bewertet',
      statusContent: 'Das Ergebnis erhältst du zusätzlich per E-Mail.',
      subHeadline: 'Jetzt inserieren und passende Mieter finden',
      additionalUlClass: '',
      ctaButton: 'Jetzt inserieren',
      bulletPoint1: (
        <span>
          <b className='highlighter'>Kostenloses Inserat</b> schalten und <br className='palm-hide' />
          einfach Mieter finden¹.
        </span>
      ),
      bulletPoint2: (
        <span>
          <b>Größte Reichweite</b> bei Deutschlands <br className='palm-hide' /> beliebtestem Immobilienportal nutzen².
        </span>
      ),
      bulletPoint3: (
        <span>
          <b>Umfassende Services </b>mit 96% <br className='palm-hide' /> Kundenzufriedenheit erleben³.
        </span>
      ),
    },
  ],
  [
    Intent.INDEPENDENT_LET,
    {
      statusHeadline: 'Immobilie erfolgreich bewertet',
      statusContent: 'Das Ergebnis erhältst du zusätzlich per E-Mail.',
      subHeadline: 'Jetzt inserieren und passende Mieter finden',
      additionalUlClass: '',
      ctaButton: 'Jetzt inserieren',
      bulletPoint1: (
        <span>
          <b className='highlighter'>Kostenloses Inserat</b> schalten und <br className='palm-hide' />
          einfach Mieter finden¹.
        </span>
      ),
      bulletPoint2: (
        <span>
          <b>Größte Reichweite</b> bei Deutschlands <br className='palm-hide' /> beliebtestem Immobilienportal nutzen².
        </span>
      ),
      bulletPoint3: (
        <span>
          <b>Umfassende Services </b>mit 96% <br className='palm-hide' /> Kundenzufriedenheit erleben³.
        </span>
      ),
    },
  ],
])
